export function formatDatesToDifferentFormats(date) {
  let mnth = ('0' + (new Date(date).getMonth() + 1)).slice(-2);
  let day = ('0' + new Date(date).getDate()).slice(-2);
  let year = new Date(date).getFullYear();
  let formattedUI = [day, mnth, year].join('.');
  let formattedISOS = [mnth, day, year].join('/');
  let formattedProvider = [year, mnth, day].join('');
  let dates = {
    formattedUI: formattedUI,
    formattedISOS: formattedISOS,
    formattedProvider: formattedProvider,
  };

  return dates;
}

export function formatDateToMonthFirst(date) {
  if(date instanceof String ) date = date.split('') ;
  return `${date[4]}${date[5]}/${date[6]}${date[7]}/${date[0]}${date[1]}${date[2]}${date[3]}`;
}

export function getPackageEndDate(startDate, packageDuration, packageDurationUnit) {
  let startDateObj = new Date(startDate);
  let duration = parseInt(packageDuration, 10);

  if (packageDurationUnit === 'Month') {
    startDateObj.setMonth(startDateObj.getMonth() + duration);
    startDateObj.setDate(startDateObj.getDate() - 1); 
  } else {
    startDateObj.setDate(startDateObj.getDate() + duration - 1);
  }

  return formatDatesToDifferentFormats(startDateObj);
}

export const getDayBeforeAndAfter = (startDate, before) => {
  let startDateObj = new Date(startDate);
  let date = before ? startDateObj.setDate(startDateObj.getDate() - 1) : startDateObj.setDate(startDateObj.getDate() + 1);
  let day = ('0' + new Date(date).getDate()).slice(-2);
  let mnth = ('0' + (new Date(date).getMonth() + 1)).slice(-2);
  return `${day}.${mnth}`;
};

export function getFilteredCountryList(mainList, subList) {
  let filteredCountries = [];
  mainList.map((country) => {
    if (!subList?.some((subCountry) => subCountry.countryCode.toLowerCase() === country.countryCode.toLowerCase())) {
      filteredCountries.push(country);
    }
  });
  return filteredCountries;
}

export function getSelectedDaysCount(startDate, endDate) {
  const selectedStartDate = new Date(startDate);
  const selectedEndDate = new Date(endDate);
  const diffTime = Math.abs(selectedEndDate - selectedStartDate);
  const daysCount = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  return daysCount;
}

export function isSuitableDates(packageData, startDate, endDate) {
  const { packageDuration, packageDurationUnit } = packageData || {};
  if (!packageDuration || packageDuration == 0) return true;
  const selectedDaysCount = getSelectedDaysCount(startDate, endDate);
  if (packageDurationUnit === 'Month') {
    return parseInt(selectedDaysCount) <= parseInt(packageDuration) * 30;
  }
  return parseInt(selectedDaysCount) <= parseInt(packageDuration);
}

export function formatPackageDurationLabel(duration, packageDurationUnit) {
  const amount = parseInt(duration, 10);
  if (!amount || amount <= 0) return '';

  if (packageDurationUnit === 'Month') {
    return amount === 1 ? 'חודש' : `${amount} חודשים`;
  }

  return amount === 1 ? 'יום' : `${amount} ימים`;
}

function getMemberPhone(member) {
  if (!member) return null;
  const phone = typeof member === 'string' ? member : member.phone;
  return phone ? String(phone).trim() : null;
}

/** Unique subscriber numbers selected for family bundle install (flight manager + members). */
export function getFamilyBundleInstallPhones(familyBundleData) {
  if (!familyBundleData) return [];
  const phones = [];
  const flightManagerPhone = getMemberPhone(familyBundleData.flightManager);
  if (flightManagerPhone) phones.push(flightManagerPhone);
  (familyBundleData.selectedMembers || []).forEach((member) => {
    const phone = getMemberPhone(member);
    if (phone) phones.push(phone);
  });
  return [...new Set(phones)];
}

/** Formats blocked subscriber numbers for popup HTML (one per line). */
export function formatBlockedPhonesForPopup(phones) {
  if (!phones?.length) return '';

  const content = phones
    .map(
      (phone) =>
        `<span class="d-block bold"><bdi>${phone}</bdi></span>`
    )
    .join('');

  return `<div style="text-align: start; margin: auto 12%;">${content}</div>`;
}

/** Formats data usage display for package details.*/
export function getDataUsageDisplay(data) {
  if (!data) {
    return {value: null, unit: null};
  }

  if (data.quantity != null) {
    return {value: data.quantity, unit: 'MB'};
  }

  return {value: data.value, unit: data.unit};
}

